import {Modal} from 'bootstrap';


/**
 * @see https://getbootstrap.com/docs/5.0/components/modal/#via-javascript
 */
const setupModalForms = () =>
{
	const formButtons = document.querySelectorAll( '[data-modal-form]' );

	formButtons.forEach( formButton =>
	{
		const formId = formButton.dataset.modalForm;
		const title  = formButton.dataset.title;

		formButton.addEventListener( 'click', e =>
		{
			const modalElem = document.querySelector( '#modal-form-' + formId );

			e.preventDefault();

			if (title) {
				const heading = modalElem.querySelector( '.modal-header h5' );

				if (heading instanceof Element) {
					heading.innerHTML = title;
				}
			}

			if (modalElem instanceof Element) {

				const formModal = new Modal( modalElem, {} );

				formModal.show();
			}
		} );
	} );
};


/**
 *
 */
export default setupModalForms;